import React from "react";
import BreadCrumb from "../BreadCrumb/BreadCrumb";

function Header(props) {
  const { breadCrumbsData, heading } = props;
  return (
    <>
      <BreadCrumb data={breadCrumbsData} lastData={heading} />
      <div className="ModalHeader">
        <h1
          style={{
            margin: "20px 0 0 0",
            fontSize: "25px",
            color: "#F26639",
            textTransform: "uppercase",
          }}
        >
          {heading}
        </h1>
      </div>
    </>
  );
}

export default Header;
